import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionExampleRow } from "../types";

const ModuleVersionExamplesTableNameCell = ({
  item: example,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionExampleRow>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./../example/${encodeURIComponent(example.id)}`}>
        {example.id}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ModuleVersionExamplesTableNameCell;
